// The kind of ending the game reached, by material (rook ending, opposite-
// coloured bishops, …; `endingTypeOfPositions` in `@chess/api-ending-case`). Like
// `blunder` it lives in the scan's facts (`GameFacts.endingType`), which the
// filter does not read: whoever applies the filter resolves it first into
// `ids` (the game store's `resolveFilter`). Unresolved, it matches no game.
import { oneOf, type FilterCriterion } from '../criterion.ts';
import { ENDING_TYPE_LABEL, ENDING_TYPES } from '@chess/api-ending-case';

export const endingType: FilterCriterion<'endingType'> = {
  key: 'endingType',
  query: 'ending-type',
  many: true,
  parse: oneOf(ENDING_TYPES),
  format: (v) => v,
  matches: (_game, _v, filter) => !!filter.ids,
  control: {
    kind: 'choice',
    order: 65,
    more: true,
    label: 'Ending type',
    options: ENDING_TYPES.map((t) => [t, ENDING_TYPE_LABEL[t]] as [typeof t, string]),
  },
};
